import { Reducer } from "@reduxjs/toolkit";
import { StationStatus } from "./queryStationStatus";
import { createAsyncEntitySlice } from "../../../Store/Entities/createAsyncEntitySlice";
import { AsyncEntityState, createForeignKeySelector } from "../../../Store/Thunks/asyncEntityStateUtil";
import { RootState } from "../../../Store";
import { EnqueueFetcher } from "../../../Store/Thunks/enqueueFetcher";
import { fetchStationStatusByStationIdsThunk } from "../../../Store/Thunks/stationStatusByIds";
import { entityByIdWithStatusHookFactory } from "../../../Store/Entities/entityByIdWithStatusHookFactory";

// Explicit typing is required
const {reducer, actions, entityAdapter, getSelectors}  = createAsyncEntitySlice({
  name: "stationStatus",
  reducers: {
    },
  fetchByIdsThunk: fetchStationStatusByStationIdsThunk,
  selectId:(stationStatus) => stationStatus.stationId
})

export const stationStatusReducer = reducer as Reducer<AsyncEntityState<StationStatus, number>>;

const selectState = (state: RootState) => state.graphQlData.stationStatus;

const {addOne, addMany, upsertOne, upsertMany, removeAll, removeOne, clearPendingIds, addPendingId, addLoadingIds} = actions;
export const {selectById: selectStationStatusById, selectAll: SelectAllStationStatus} = entityAdapter.getSelectors(selectState);

const stationStatusByIdFetcher = new EnqueueFetcher(fetchStationStatusByStationIdsThunk, selectState, clearPendingIds, addPendingId, addLoadingIds)

export const upsertStationStatus = upsertMany;

export const dispatchFetchStationStatusById = stationStatusByIdFetcher.enqueueFetchById;

export const {selectEntitiesByForeignKey: selectStationStatusByStationId} = createForeignKeySelector<StationStatus, number, AsyncEntityState<StationStatus, number>, number>((state) => state.graphQlData?.stationStatus, "stationId");
const selectLoadingIds = getSelectors(selectState).selectLoadingIds;

export const useStationStatusById = entityByIdWithStatusHookFactory<StationStatus, number>(stationStatusByIdFetcher.enqueueFetchById, selectStationStatusById, selectLoadingIds )
